import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Box, Link } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

export function TenantSubscription() {
  return (
    <Box>
      <FormattedMessage
        id="tenant.subscription.text"
        defaultMessage="For subscription, please contact our Service Desk at: "
      />
      <Link textDecor="underline" href={`mailto:support@ranawaterintelligence.com}`}>
        support@ranawaterintelligence.com
        <ExternalLinkIcon ml={1} mb={1} />
      </Link>
    </Box>
  );
}
